import posthog from "posthog-js";

export const onClientEntry = () => {
  posthog.init(process.env.GATSBY_POSTHOG_KEY as string, {
    api_host: process.env.GATSBY_POSTHOG_HOST as string,
    ui_host: "https://us.posthog.com",
    person_profiles: "identified_only",
  });
};

export const onRouteUpdate = () => {
  window.scrollTo(0, 0);
};
